module.exports = __webpack_public_path__ + "img/my-banner@2x.961e3a6d.png";